import { Component } from 'react';
import Checkbox from '@mui/material/Checkbox';
import '../InterventionReportField.css'
import { getCurrentFunctionName } from '../../../performanceModeManager';

class InterventionCheckBox extends Component {

    onChange(e){
        let fieldValue = this.props.value;
        fieldValue.value_bool = e.target.checked
        this.props.fieldValueChange(fieldValue);
    }

    render() {
        console.perfLog(getCurrentFunctionName());
        return (
            <div className="row col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding intervention-checkbox-margin">
                <div className="col-lg-9 col-md-9 col-sm-9 col-9 without-padding label-ellipsis">
                    <span>{this.props.model.name}</span>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-3 col-3 without-padding">
                    <Checkbox {...this.props.inputProperties} label={this.props.model.name}
                        checked={this.props.value.value_bool} onChange={this.onChange.bind(this)}
                        className={this.props.inputProperties.className + " small-checkbox " + (this.props.inputProperties.disabled ? "light-disabled" : "")}/>
                </div>
            </div>
        )
    }
}

export default InterventionCheckBox;
